import Alert from "react-bootstrap/esm/Alert";
import { resources } from "@constants/hardcoded-strings";
import {
    EMAIL_TEMPLATE_FIELDS_DCUI_FROM_EMAIL_ADDRESS_PROPERTY_NAME,
    EMAIL_TEMPLATE_FIELDS_PIN_FROM_EMAIL_ADDRESS_PROPERTY_NAME
} from "@constants/messaging-template-constants";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { PreviewEntityTypes } from "@enums/preview-entity-types";
import {
    ThemingMessagingSelectedTemplateValidationErrors,
    ThemingMessagingTemplateValidationWarnings,
    ThemingMessagingValidationErrors
} from "@idw-types/common/validation/common/theming-validation-errors";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { EmailTemplateFields } from "@idw-types/common/email-template-fields";
import { getMessagingTemplateContentValidationErrors, getMessagingTemplateVariablesValidationErrors } from "@utils/validation/messaging-template/messaging-template-validation-util";

export const getThemingMessagingValidationErrors = (
    previewEntityType: PreviewEntityTypes,
    isUsingThemedUI: boolean,
    showMessagingTab: boolean,
    showEmailInputs: boolean,
    emailTemplateFields: EmailTemplateFields,
    availableMessagingTemplateTypes: Array<MessagingTemplateTypes>,
    selectedMessagingTemplates: Array<FormattedMessagingTemplate>

): ThemingMessagingValidationErrors => {
    let count = 0;

    let pinFromEmailAddressError = null;
    let dcuiFromEmailAddressError = null;
    const templateErrors: { [key in MessagingTemplateTypes]?: ThemingMessagingSelectedTemplateValidationErrors } = {};
    const templateWarnings: ThemingMessagingTemplateValidationWarnings = {};

    if (isUsingThemedUI && showMessagingTab && previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE) {

        if (showEmailInputs && emailTemplateFields) {
            if (Object.keys(emailTemplateFields).includes(EMAIL_TEMPLATE_FIELDS_PIN_FROM_EMAIL_ADDRESS_PROPERTY_NAME)) {
                if (!emailTemplateFields.pinFromEmailAddress) {
                    count += 1;
                    pinFromEmailAddressError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                } else if (!/\b[\w.-]+@[\w.-]+\.\w{2,4}\b/.test(emailTemplateFields.pinFromEmailAddress)) {
                    count += 1;
                    pinFromEmailAddressError = <ErrorAlert><span>Please enter a valid email address</span></ErrorAlert>;
                }
            }

            if (Object.keys(emailTemplateFields).includes(EMAIL_TEMPLATE_FIELDS_DCUI_FROM_EMAIL_ADDRESS_PROPERTY_NAME)) {
                if (!emailTemplateFields.dcuiFromEmailAddress) {
                    count += 1;
                    dcuiFromEmailAddressError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                } else if (!/\b[\w.-]+@[\w.-]+\.\w{2,4}\b/.test(emailTemplateFields.dcuiFromEmailAddress)) {
                    count += 1;
                    dcuiFromEmailAddressError = <ErrorAlert><span>Please enter a valid email address</span></ErrorAlert>;
                }
            }
        }

        availableMessagingTemplateTypes.forEach(templateType => {
            const foundTemplate = selectedMessagingTemplates.find(template => template.type === templateType);
            if (!foundTemplate) {
                templateWarnings[templateType] = getTemplateWarningAlert();
            } else {
                const content = getMessagingTemplateContentValidationErrors(foundTemplate);
                const variables = getMessagingTemplateVariablesValidationErrors(foundTemplate);

                count += content.count + variables.count;

                templateErrors[templateType] = {
                    content, variables
                };
            }
        });
    }

    return {
        pinFromEmailAddressError,
        dcuiFromEmailAddressError,
        templateErrors,
        templateWarnings,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.messaging.tabName}
            errorCount={count}
        />
    };
};

const getTemplateWarningAlert = () => {
    return <Alert variant={"warning"} >{resources.common.requiredField}</Alert>;
}